'use strict';
import { declOfNum } from "../../_scripts/helpers";

export default class Services {
	constructor(root) {
		this.root = root;
		if (!this.root.querySelector('[data-choose-service]')) return false;
		this._matchHTML();
		this._checkboxesHandler();
		this._formHandler();
		// this._addBtnHandler();
		// this._removeAllBtnHandler();
	}

	_matchHTML() {
		this.checkboxes = [...this.root.querySelectorAll('[data-service-input]')];
		this.addBtn = this.root.querySelector('[data-add-services]');
		this.itemId = this.root.querySelector('[data-item-basket-id]').dataset.itemBasketId;
		this.serviceIds = [];
		// this.checkedServices = 0;
		this.servicesAdd = this.root.querySelector('.services-add');
		this.modalTextStub = this.root.querySelector('[data-text-stub]');
		this.modalCountText = this.root.querySelector('[data-services-count]');
		this.itemRow = document.getElementById(this.itemId);
		if (!this.itemRow) {
			this.itemRow = document.querySelector("[data-cart-item-id='"+this.itemId+"']");
		}
		this.textStub = this.itemRow.querySelector('[data-text-stub]');
		this.countText = this.itemRow.querySelector('[data-services-count]');
		this.removeBtn = this.root.querySelector('[data-remove-all]');
		this.form = this.root.querySelector('[data-services-form]')
	}

	_createServicesArray(checkbox) {
		let val = checkbox.value,
			index = this.serviceIds.indexOf(val);

		if (checkbox.checked) {

			if (index === -1) {
				this.serviceIds.push(val);
			}

		} else {

			if (index >= 0) {
				this.serviceIds.splice(index, 1);
			}
		}

		// this._servicesAdd();
		this._servicesCount(this.modalTextStub, this.modalCountText);
	}

	_checkboxesHandler() {
		this.checkboxes.forEach(checkbox => {

			if (checkbox.checked) {
				this._createServicesArray(checkbox);
			};

			checkbox.addEventListener('change', e => {
				this._createServicesArray(checkbox);
			})
		})

	}

	_servicesAdd() {
		if (this.serviceIds.length > 0) {
			this.servicesAdd.classList.remove('is-disabled');
		} else {
			this.servicesAdd.classList.add('is-disabled');
		}
	}

	_servicesCount(stub, text) {
		let count = this.serviceIds.length;

		if (count > 0) {
			text.innerHTML = `${declOfNum(count, ['Выбрана', 'Выбрано', 'Выбрано'])} ${count} ${declOfNum(count, ['услуга', 'услуги', 'услуг'])}`;
			stub.classList.add('is-hidden');
			text.classList.remove('is-hidden');
		} else {
			stub.classList.remove('is-hidden');
			text.classList.add('is-hidden');
		}
	}

	_addBtnHandler() {
		this.addBtn.addEventListener('click', e => {
			e.preventDefault();

			// if (this.serviceIds.length > 0) {
				let url = this.addBtn.href,
					data = {"serviceId" : this.serviceIds, "itemId": this.itemId},
					that = this;

				 $.ajax({
					url: url,
					type: 'POST',
					data: data,
					dataType: 'json',
					success: function(res) {
						if (res.success) {
							that._servicesCount(that.textStub, that.countText);
							closeModals();
						}
					}
				});
			// } else {
			// 	return false;
			// }
		});
	}

	_removeAllBtnHandler() {
		this.removeBtn.addEventListener('click', e => {
			e.preventDefault();

			if (this.serviceIds.length > 0){
				let url = this.addBtn.href,
					data = {"serviceId" : [0], "itemId": this.itemId},
					that = this;

				$.ajax({
					url: url,
					type: 'POST',
					data: data,
					dataType: 'json',
					success: function(res) {
						if (res.success) {
							that.serviceIds = 0;
							that._servicesCount(that.textStub, that.countText);
							closeModals()
						}
					}
				});
			}

		})
	}

	_formHandler() {
		this._matchHTML();

		if (!this.form) return false;

		this.form.addEventListener('submit', e => {
			e.preventDefault();

			let
				data = $(this.form).serialize(),
				that = this;

			 $.ajax({
				url: this.form.action,
				type: 'POST',
				data: data,
				dataType: 'json',
				success: function(res) {
					if (res.success) {
						that._servicesCount(that.textStub, that.countText);
						closeModals()
					}
				}
			});
		})
	}
}
